import { useEffect, useRef } from "react";
import { MdLockOpen } from "react-icons/md";

interface RequestUnlockModalProps {
  isOpen: boolean;
  onClose: () => void;
  lockingUserDisplayName: string;
  fieldId: string;
  lockingUserId: string;
  sendFieldUnlockRequest: (fieldId: string, targetUserId: string) => void;
}

export const RequestUnlockModal = ({
  isOpen,
  onClose,
  lockingUserDisplayName,
  fieldId,
  lockingUserId,
  sendFieldUnlockRequest,
}: RequestUnlockModalProps) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (isOpen) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [isOpen]);

  const handleConfirm = () => {
    if (lockingUserId) {
      sendFieldUnlockRequest(fieldId, lockingUserId);
    }
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <dialog
      ref={dialogRef}
      id={`request_unlock_modal_${fieldId}`}
      className="modal h-full w-full"
    >
      <div className="modal-box max-w-lg bg-white p-0 text-briefly-text-primary">
        <div className="modal-content flex items-start gap-6 px-8 pb-10 pt-12">
          <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-yellow-100">
            <MdLockOpen className="h-6 w-6 text-yellow-600" />
          </div>
          <div className="flex flex-col gap-2">
            <h3 className="text-xl font-bold text-briefly-text-primary">
              Request Access to this field?
            </h3>
            <p className="text-md text-briefly-text-secondary">
              You are requesting access to a field that{" "}
              <strong>{lockingUserDisplayName}</strong> is currently editing.
              They will be notified and given a few seconds to respond.
            </p>
          </div>
        </div>
        <div className="modal-action my-0 flex w-full justify-end bg-gray-100 p-6">
          <button
            type="button"
            className="btn-med text-md mr-3 rounded-md border border-briefly-action bg-white px-6 py-3 text-briefly-text-primary hover:bg-gray-100 focus:outline-none"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn-med text-md rounded-md border-none bg-briefly-action px-6 py-3 text-white hover:bg-briefly-action/90 focus:outline-none"
            onClick={handleConfirm}
          >
            Send Request
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default RequestUnlockModal;
